// extracted by mini-css-extract-plugin
export default {"wrapper":"BarChart_wrapper_f116a","bar":"BarChart_bar_f1c3b","barResize":"BarChart_barResize_b39ab","barActive":"BarChart_barActive_c4dd3","text":"BarChart_text_baea3"};